module.exports = __webpack_public_path__ + "static/media/DS-DIGI.63f874d1.TTF";